// Shared client-side validation for the public money/lead forms (Review 3 #35).
// One validation dialect across /register, workshop registration, pack checkout,
// the waitlist, and /contact — so a parent gets the same warm, on-brand guidance
// everywhere and no form ever ships blank data to the server.

// The email shape used everywhere (mirrors RegisterStudent's original regex).
export const emailRe = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const isValidEmail = (value) => emailRe.test(String(value || '').trim());

// The server callables stay the authoritative backstop, but their raw rejection
// strings name internal field paths ("Missing or invalid fields: parent.email,
// student.age") or read as system text ("Missing required fields"). A parent
// must never see those. Map any such validation leak to one warm, generic line;
// pass genuinely human messages (capacity, age-range, config) through unchanged.
const FIELD_PATH_LEAK = /missing (required|or invalid) fields|\b(parent|student|guardian|emergencyContact)\.[a-z]/i;

export function friendlyServerError(err, fallback = 'Something went wrong. Please try again.') {
	const raw = (err && err.message) || '';
	if (!raw) return fallback;
	if (FIELD_PATH_LEAK.test(raw)) {
		return 'Please double-check your details — something looks incomplete — then try again.';
	}
	return raw;
}
